import CUSTOMER_LOGOS from './customer-logos';

/**
 * Displays a list of organizations who (proudly) trust FOSSA.
 */
const TrustedBy = () => (
  <div className="fossa-auth__marketing__trusted-by">
    <div className="fossa-auth__marketing__trusted-by__text">
      Trusted by
    </div>
    <ul className="fossa-auth__marketing__trusted-by__logos">
      {Object.entries(CUSTOMER_LOGOS).map(([key, Logo]) => (
        <li className="fossa-auth__marketing__trusted-by__logos__item" key={key}>
          <Logo />
        </li>
      ))}
    </ul>
  </div>
);

export default TrustedBy;
